import * as serverApi from './server'

export const create = (payload) => serverApi.post('/v3/dashboards', payload)
export const getAll = (queryParams) => serverApi.get('/v3/dashboards', queryParams)
export const edit = ({ dashboardId, tabs, ...filters }) => serverApi.patch(`/v3/dashboards/${dashboardId}`, { filters, tabs })
export const deleteDashboards = ({ dashboardIds, ...filters }) => serverApi.post('/v3/dashboards/remove', { dashboardIds, filters })
